export { default } from "./TabGeneralInquiry";
